// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ReplaceCardResultModel {
    static getAttributeTypeMap() {
        return ReplaceCardResultModel.attributeTypeMap;
    }
}
ReplaceCardResultModel.discriminator = undefined;
ReplaceCardResultModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "orderReferenceNumber",
        "baseName": "orderReferenceNumber",
        "type": "string"
    }
];
//# sourceMappingURL=replaceCardResultModel.js.map